function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M9.32812 11.9375L9.5625 12.1719C9.84375 12.4531 9.84375 12.7188 9.5625 12.9688L2.57812 20H5.4375C5.8125 20 6 20.1875 6 20.5625V20.9375C6 21.3125 5.8125 21.5 5.4375 21.5H0.5625C0.1875 21.5 0 21.3125 0 20.9375V16.0625C0 15.6875 0.1875 15.5 0.5625 15.5H0.9375C1.3125 15.5 1.5 15.6875 1.5 16.0625V18.9219L8.53125 11.9375C8.78125 11.6562 9.04688 11.6562 9.32812 11.9375ZM20.4375 0.5C20.8125 0.5 21 0.6875 21 1.0625V5.9375C21 6.3125 20.8125 6.5 20.4375 6.5H20.0625C19.6875 6.5 19.5 6.3125 19.5 5.9375V3.07812L12.4688 10.0625C12.2188 10.3438 11.9531 10.3438 11.6719 10.0625L11.4375 9.82812C11.1562 9.54688 11.1562 9.28125 11.4375 9.03125L18.4219 2H15.5625C15.1875 2 15 1.8125 15 1.4375V1.0625C15 0.6875 15.1875 0.5 15.5625 0.5H20.4375Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.9ce21ec6fc5743d108f305e6bf1a7af7.svg";
export { ForwardRef as ReactComponent };